// extracted by mini-css-extract-plugin
export default {"heading":"NavBar_heading__UeuLZ","headerText":"NavBar_headerText__MxiCa","contentContainer":"NavBar_contentContainer__eyay7","back_btn":"NavBar_back_btn__uqqSq"};